import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobDetail from "./pages/JobDetail";
import Apply from "./pages/Apply";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Hire from "./pages/Hire";
import About from "./pages/About";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Saved from "./pages/dashboard/Saved";
import Applications from "./pages/dashboard/Applications";
import Profile from "./pages/dashboard/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: process session_id synchronously to avoid race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/job/:id" element={<JobDetail />} />
        <Route path="/apply/:id" element={<ProtectedRoute><Apply /></ProtectedRoute>} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/hire" element={<Hire />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/dashboard/saved" element={<ProtectedRoute><Saved /></ProtectedRoute>} />
        <Route path="/dashboard/applications" element={<ProtectedRoute><Applications /></ProtectedRoute>} />
        <Route path="/dashboard/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </AdminAuthProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}
